/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import OTPInput, { ResendOTP } from "otp-input-react";
import { virifyOtp } from './api';




/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/


export function UserVirification({ returnFunction = null, mobile, closePOup, title = "Verification", description = "Enter the verification code sent to" }) {

    const [loading, setLoading] = useState(false)
    const [OTP, setOTP] = useState("");
    const [status, setStatus] = useState('');
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true)
        setTimeout(() => {
            virifyOtp({ mobile: mobile, otp: OTP }).then(({ data }) => {

                if (Number(data.code) === 0) {
                    setStatus(data?.message);
                    setLoading(false)
                    if (returnFunction) {
                        // returnFunction(1)
                    }
                } else {
                    if (returnFunction) {
                        returnFunction(1)
                    }
                    setStatus(data?.message);
                }
            }).catch(() => {
                setLoading(false)
                setStatus('Something wrong!')
            })
        }, 1000)

    }
    const renderButton = (buttonProps) => {
        return buttonProps.remainingTime !== 0 ? `Please wait for ${buttonProps.remainingTime} sec` : <> <span className="text-muted me-1">Didn’t get the code ?</span> <a href="#" onClick={() => ResendOTP()} className="link-primary fw-semibolder fs-5 me-1">Resend</a></>
    };
    const renderTime = (remainingTime) => {
        return <></>
    };
    return (
        <>
            <div className="mx-auto">
                <form
                    className='form w-100'
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className="text-center mb-3">
                        {/* begin::Title */}
                        <h1 className="text-dark mb-3">{title}</h1>
                        {/* end::Title */}
                        {/* begin::Sub-title */}
                        <div className="text-muted fw-semibold fs-5 mb-5">{description} {mobile.replace(/.(?=.{4})/g, '*')}</div>
                        {/* end::Sub-title */}
                        {/* begin::Mobile no */}
                        {/* <div className="fw-semibolder text-dark fs-3">{mobile.replace(/.(?=.{4})/g, '*')}</div> */}
                        {/* end::Mobile no */}
                        {status !== "" &&
                            <div className="text-danger fw-semibold fs-5 mb-5">{status}</div>
                        }
                    </div>
                    <div className="mb-10 px-md-10">
                        {/* begin::Label */}
                        <div className="fw-semibolder text-start text-dark fs-6 mb-1 ms-1">Type your 4 digit otp code</div>
                        {/* end::Label */}
                        {/* begin::Input group */}
                        <div className="d-flex flex-wrap flex-stack">
                            <OTPInput
                                value={OTP} onChange={setOTP}
                                inputClassName={`form-control form-control-solid  h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2`}
                                autoFocus OTPLength={4}
                                otpType="number"
                                disabled={false} />

                        </div>
                        {/*begin::Input group*/}
                    </div>
                    {/* begin::Heading */}


                    {/* begin::Action */}
                    <div className='text-center'>
                        <div className='d-flex flex-stack'>
                            <button
                                type='button'
                                id='kt_cancell_in_submit'
                                className='btn btn-lg w-100 mb-5 me-3'
                                style={{ background: '#0E295E' }}
                                //disabled={loading}
                                onClick={() => closePOup()}
                            >
                                <span className='indicator-label text-white'>Cancel</span>
                            </button>
                            <button
                                type='submit'
                                id='kt_otp_in_submit'
                                className='btn btn-lg btn-primary w-100 mb-5'
                                disabled={!OTP}
                            >
                                {!loading && <span className='indicator-label'>Continue</span>}
                                {loading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                        <div className="text-center fw-semibold fs-5">
                            <ResendOTP renderButton={renderButton} renderTime={renderTime} />
                            {/*                           
                            <span className="text-muted me-1">Didn’t get the code ?</span>
                            <a href="#" onClick={() => ResendOTP()} className="link-primary fw-semibolder fs-5 me-1">Resend</a> */}
                        </div>
                    </div>


                </form>


            </div>

        </>
    )
}
